module.exports = __webpack_public_path__ + "static/media/icon-info.d8582d9c.svg";